(function(){
    'use strict';
    angular.module('app').controller('AccountingUpdateCaseModalController', AccountingUpdateCaseModalController);
    AccountingUpdateCaseModalController.$inject = [];

    function AccountingUpdateCaseModalController(){
        const vm = this;
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingUpdateCaseModalController.js